'use client';

import type { ProfileFormInput } from '@eliadmin/core/src/components/dlz/account/profile/profile-schema';
import { formFields } from '@eliadmin/core/src/components/dlz/forms/form-fields';

/** The DLZ form fields bound to the profile form. */
export const { TextField, CountryField, CheckboxField } = formFields<ProfileFormInput>();
